import React from 'react';
import styled from '@emotion/styled';
import { BrandUtil, EmotionBreakpoint } from 'dw-us-ui';

const Layout = styled.div`
	display: flex;
	max-width: 100%;
	width: 100%;
	max-height: 100%;
	height: 100%;
	padding: 144px 45px 124px 45px;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	background: ${(props) =>
		props.membershipPerksBackgroundColor
			? props.membershipPerksBackgroundColor
			: '#fff'};
	${EmotionBreakpoint('mobile')} {
		width: 100%;
		height: 100%;
		max-height: 100%;
		padding: 50px 16px 30px 16px;
		align-items: center;
	}
`;

const MainContainer = styled.div`
	max-width: 1152px;
	max-height: 100%;
	width: 100%;
	height: auto;
	display: flex;
	padding: 0px 0px 0px 0px;
	flex-direction: column;
	align-items: center;
	border: ${(props) =>
		props.mainContainerBorderColor
			? props.mainContainerBorderColor
			: '1px solid #b1927b'};
	${EmotionBreakpoint('mobile')} {
		max-height: 100%;
		height: 100%;
		gap: 0px;
	}
	${EmotionBreakpoint('tablet')} {
	}
`;
const Eyebrow = styled.div`
	display: none;
	${EmotionBreakpoint('mobile')} {
		display: flex;
		align-self: center;
		color: ${(props) =>
			props.membershipPerksEyebrowColor
				? props.membershipPerksEyebrowColor
				: '#cf004f'}
		text-align: center;
		font-family:  ${(props) =>
			props.membershipPerksEyebrowFont
				? props.membershipPerksEyebrowFont
				: 'Open Sans'}, sans-serif;
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 19.6px;
		bottom: -53px;
		text-transform: uppercase;
	}
`;
const Headline = styled.h3`
	align-self: center;
	color: ${(props) =>
		props.membershipPerksHeadlineColor
			? props.membershipPerksHeadlineColor
			: '#222'};
	text-align: center;
	font-family: ${(props) =>
		props.membershipPerksHeadlineFont
			? props.membershipPerksHeadlineFont
			: 'Noto Serif'};
	font-size: 32px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	position: relative;
	bottom: 27px;
	background-color: ${(props) =>
		props.membershipPerksBackgroundColor
			? props.membershipPerksBackgroundColor
			: '#fff'};
	max-width: 30%;
	width: 100%;
	${EmotionBreakpoint('mobile')} {
		font-size: 26px;
		line-height: 27px;
		max-width: fit-content;
		bottom: 2px;
	}
	${EmotionBreakpoint('tablet')} {
		font-size: 22px;
	}
`;
const PerksContainer = styled.div`
	gap: 87px;
	max-width: 100%;
	width: 100%;
	max-height: 100%;
	width: 100%;
	display: flex;
	justify-content: space-evenly;
	padding: 43px 80px 80px 80px;
	.column {
		display: flex;
		flex-direction: column;
		gap: 60px;
	}
	${EmotionBreakpoint('mobile')} {
		flex-direction: column;
		gap: 40px;
		max-width: 100%;
		width: 100%;
		max-height: 100%;
		width: 100%;
		align-items: center;
		padding: 10px 30px 40px;
		margin-top: 20px;
		.column {
			gap: 40px;
		}
	}
	${EmotionBreakpoint('tablet')} {
		gap: 0px;
		justify-content: space-around;
		padding: 43px 0px 81px 58px;
	}
`;
const PerksList = styled.div`
	flex-basis: calc(50% - 10px);
	height: 100%;
	width: 100%;
	text-align: left;
	${EmotionBreakpoint('mobile')} {
		flex-basis: auto;
		max-width: 344px;
		width: 100%;
		max-height: 832px;
		height: 100%;
		align-items: center;
		text-align: left;
	}
	${EmotionBreakpoint('tablet')} {
	}
`;
const Perks = styled.div`
	display: flex;
	flex-direction: row;
	gap: 20px;
	p:first-of-type {
		font-weight: 600;
		padding-bottom: 5px;
		text-align: left;
	}
	p:not(:first-of-type) {
		width: 295px;
		text-align: left;
	}

	${EmotionBreakpoint('tablet')} {
		gap: 15px;
		p:not(:first-of-type) {
			width: 220px;
			text-align: left;
		}
	}
	${EmotionBreakpoint('mobile')} {
		gap: 17px;

		p:first-of-type {
			font-weight: 600;
			padding-bottom: 2px;
			width: auto;
		}

		p:not(:first-of-type) {
			font-weight: 400;
			width: 240px;
		}
	}
	p {
		width: 300px;
		color: ${(props) =>
			props.membershipPerksHeadlineColor
				? props.membershipPerksHeadlineColor
				: '#222'};
		font-family: ${(props) =>
				props.membershipPerksEyebrowFont
					? props.membershipPerksEyebrowFont
					: 'Open Sans'},
			sans-serif;
		font-size: 14px;
		font-style: normal;
		line-height: 130%;
		text-align: left;
	}
`;

const MembershipPerks = ({ contentfulData }) => {
	const membershipPerks = contentfulData?.membershipPerks || [];

	if (membershipPerks.length === 0) {
		return null;
	}

	const halfLength = Math.ceil(membershipPerks?.length / 2);
	const perks1 = membershipPerks?.slice(0, halfLength);
	const perks2 = membershipPerks?.slice(halfLength);

	return (
		<Layout
			membershipPerksBackgroundColor={
				contentfulData?.membershipPerksBackgroundColor
			}
		>
			<Eyebrow
				membershipPerksEyebrowColor={
					contentfulData?.membershipPerksEyebrowColor
				}
				membershipPerksEyebrowFont={contentfulData?.membershipPerksEyebrowFont}
			>
				{contentfulData?.perksEyebrow}
			</Eyebrow>
			<MainContainer
				mainContainerBorderColor={contentfulData?.mainContainerBorderColor}
			>
				<Headline
					membershipPerksHeadlineFont={
						contentfulData?.membershipPerksHeadlineFont
					}
					membershipPerksHeadlineColor={
						contentfulData?.membershipPerksHeadlineColor
					}
					membershipPerksBackgroundColor={
						contentfulData?.membershipPerksBackgroundColor
					}
				>
					{contentfulData?.membershipPerksHeadlineText}
				</Headline>
				<PerksContainer>
					<div className='column'>
						{perks1.map((perk, index) => (
							<PerksList key={index}>
								<Perks
									dangerouslySetInnerHTML={{ __html: perk.fields.htmlContent }}
								></Perks>
							</PerksList>
						))}
					</div>
					<div className='column'>
						{perks2.map((perk, index) => (
							<PerksList key={index}>
								<Perks
									dangerouslySetInnerHTML={{ __html: perk.fields.htmlContent }}
								></Perks>
							</PerksList>
						))}
					</div>
				</PerksContainer>
			</MainContainer>
		</Layout>
	);
};
export default MembershipPerks;
